import {
  AccountingSystemForCalculatingFinancialStatistics,
  MeetingAdminResponse,
  StudentToOrgTransactionResponse,
  ApprovalStatus,
  StudentToOrgTransactionType,
} from "client/openapi";
import "./TransactionSettings.css"; // Add some nice styles for the dropdowns

function TransactionSettings({
  accountingSystem,
  setAccountingSystem,
  setTransactions,
  transactionTypeFilter,
  setTransactionTypeFilter,
  adminApprovalFilter,
  setAdminApprovalFilter,
}: {
  accountingSystem: AccountingSystemForCalculatingFinancialStatistics;
  setAccountingSystem: (
    accountingSystem: AccountingSystemForCalculatingFinancialStatistics
  ) => void;
  setTransactions: (
    transactions: StudentToOrgTransactionResponse[] | MeetingAdminResponse[]
  ) => void;
  transactionTypeFilter: StudentToOrgTransactionType | "all";
  setTransactionTypeFilter: (
    value: StudentToOrgTransactionType | "all"
  ) => void;
  adminApprovalFilter: ApprovalStatus | "all";
  setAdminApprovalFilter: (value: ApprovalStatus | "all") => void;
}) {
  return (
    <div className="transaction-settings-container">
      <div className="flex items-center mx-4">
        <div className="toggle-container">
          <button
            className={`toggle-button ${
              accountingSystem ===
              AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS
                ? "active"
                : ""
            }`}
            onClick={() => {
              setAccountingSystem(
                AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS
              );
              setTransactions([]);
            }}
          >
            Transactions
          </button>
          <button
            className={`toggle-button ${
              accountingSystem ===
              AccountingSystemForCalculatingFinancialStatistics.MEETINGS
                ? "active"
                : ""
            }`}
            onClick={() => {
              setAccountingSystem(
                AccountingSystemForCalculatingFinancialStatistics.MEETINGS
              );
              setTransactions([]);
            }}
          >
            Meetings
          </button>
        </div>

        {/* Transaction type filter - now inline */}
        {accountingSystem ===
          AccountingSystemForCalculatingFinancialStatistics.TRANSACTIONS && (
          <div className="ml-4 flex items-center">
            <label className="mr-2 font-medium">Type:</label>
            <select
              className="rounded-lg py-1 pl-2 pr-8 border border-gray-300 text-sm w-50"
              value={transactionTypeFilter}
              onChange={(e) =>
                setTransactionTypeFilter(
                  e.target.value as StudentToOrgTransactionType | "all"
                )
              }
            >
              <option value={"all"}>All Transactions</option>
              <option
                value={
                  StudentToOrgTransactionType.AUTOMATIC_CHARGE_FOR_A_GROUP_OF_MEETINGS
                }
              >
                Automatic Charge
              </option>
              <option value={StudentToOrgTransactionType.DIRECT}>
                Direct Payment
              </option>
              <option value={StudentToOrgTransactionType.CHARGE_FOR_CREDITS}>
                Charge for Credits
              </option>
              <option
                value={StudentToOrgTransactionType.MEETING_PAID_WITH_CREDITS}
              >
                Credits Applied
              </option>
              <option value={StudentToOrgTransactionType.RESCHEDULING_FEE}>
                Rescheduling Fee
              </option>
              <option value={StudentToOrgTransactionType.CANCELLATION_FEE}>
                Cancellation Fee
              </option>
              <option value={StudentToOrgTransactionType.ABSENCE_FEE}>
                Absence Fee
              </option>
            </select>
          </div>
        )}

        {/* Admin approval filter - now inline */}
        {accountingSystem ===
          AccountingSystemForCalculatingFinancialStatistics.MEETINGS && (
          <div className="ml-4 flex items-center">
            <label className="mr-2 font-medium">Admin Approval Status:</label>
            <select
              className="rounded-lg py-1 px-2 border border-gray-300 text-sm w-40"
              value={adminApprovalFilter}
              onChange={(e) =>
                setAdminApprovalFilter(e.target.value as ApprovalStatus | "all")
              }
            >
              <option value={"all"}>All Meetings</option>
              <option value={ApprovalStatus.APPROVED}>Approved</option>
              <option value={ApprovalStatus.DENIED}>Denied</option>
              <option value={ApprovalStatus.PENDING}>Pending</option>
            </select>
          </div>
        )}
      </div>
    </div>
  );
}

export default TransactionSettings;
